import Experience from './components/Experience';
import Background from './components/Background';
//import Header from './components/Header';
import Hover from './components/Hover';
import Modale from './components/Modale';
import Youtube from './components/Youtube';
import Carousel from './components/Carousel';
import Draggable from './components/Draggable';
import Lottie from './components/Lottie';
import Preload from './components/Preload';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      // Mettez votre liste de composantes ici
      Experience,
      Background,
      Hover,
      Modale,
      Lottie,
      Preload,
      Draggable,
      Youtube,
      Carousel,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
